<template>
    <div>
        <!-- Table start -->
        <b-table class="is-capitalized"
            :data="isEmpty ? [] : tableData"
            :striped=true
            :hoverable=true
            :loading="isLoading"
            :mobile-cards=true
            :keyword="keyword"
            :default-sort-direction="defaultSortDirection"
            default-sort="last_saved">

            <template slot-scope="props"> 
                <b-table-column field="name" label="Name" sortable>
                    <a class="has-text-primary" v-on:click="$emit('view', props.row)">{{ props.row.name }}</a> 
                </b-table-column>

                <b-table-column field="staus" label="Status" sortable>
                   {{ props.row.status }}
                </b-table-column>

                <b-table-column width="180" v-for="columnInfo in customColumns" :key="columnInfo.value" :field="columnInfo.value" :label="columnInfo.lable" sortable>
                    <span 
                        v-if="columnInfo.value=='method' || 
                        columnInfo.value=='template' || 
                        columnInfo.value=='experimental_plan' || columnInfo.value=='experiment_dataset' || columnInfo.value=='report_template'"
                    >
                        {{ props.row[columnInfo.value].name }}
                    </span>
                    <span v-else>{{ props.row[columnInfo.value] }}</span>
                </b-table-column>

                <b-table-column field="last_saved" label="Updated on" centered sortable>
                    <span> 
                        {{moment(props.row.last_saved).format("DD MMMM YYYY")}}
                    </span>
                </b-table-column>

                <b-table-column field="action" label="Action">
                    <slot name="actionButtons" :tableRow="props"></slot>
                </b-table-column>

            </template>

            <template slot="empty">
                <div class="has-text-centered column" v-if="tableData">
                    <p>No data to show...</p>
                </div>

                <div v-else>
                    <b-table
                        :loading="true"
                        :focusable="true"
                        :mobile-cards="true">
                        <template>
                        </template>
                    </b-table>
                </div>
                
            </template>
        </b-table>
        <!-- Table end -->
    </div>
</template>

<script>
var moment = require('moment');
export default {
    name: "TableComponent",
    components: {
        
    },
    props: ["tableData", "keyword", "customColumns"],
    data() {
        return {
            moment:moment,
            // table props  
            isEmpty: false,
            isLoading: false,
            isOpenActive: true,
            isOpenArchived: false,
            defaultSortDirection: 'desc',
        }
    },
	computed: {
	},
    methods:{
    }
}
</script>

